import React from 'react';
import { Text } from '@doda/io-react/common';

import { ApplyButton } from '../../../../ApplyButton';
import styles from './index.module.scss';

/**
 * FooterDirectButtonのProps
 */
interface Props {
  handleApply: () => void;
  jobOfferKind: string;
}

/**
 * 求人詳細ボディーの下部
 */
export const FooterDirectButton: React.FC<Props> = ({
  handleApply,
  jobOfferKind,
}) => {
  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
    event.preventDefault();
    const { href } = event.currentTarget;
    const windowFeatures = 'popup,width=782,height=426,';
    window.open(href, 'helpWindow', windowFeatures);
  };

  return (
    <>
      <section>
        <div className={styles['jobSearchDetail-footerApplyArea']}>
          <ApplyButton
            size="L"
            width={360}
            jobOfferKind={jobOfferKind}
            onClick={handleApply}
          />

          <div
            className={styles['jobSearchDetail-footerApplyArea__button-text']}
          >
            <Text
              color="blue"
              size="14--articlePC"
              as="a"
              href="/info/help/about_apply.html"
              onClick={handleClick}
            >
              「企業に直接応募する」とは？
            </Text>
            <div
              className={
                styles['jobSearchDetail-footerApplyArea__tag-annotation']
              }
            >
              <Text as="span" color="lightGray" size="11">
                ※1
              </Text>
              <Text as="span" color="lightGray" size="11">
                ※2
              </Text>
            </div>
          </div>
        </div>
        <div className={styles['jobSearchDetail-footerApplyArea__noticetext']}>
          <Text color="gray" size="11" weight="normal">
            {NOTICE_TEXT.TEXT1}
            <br />
            {NOTICE_TEXT.TEXT2}
          </Text>
        </div>
      </section>
    </>
  );
};

/**
 * noticeの固定説明文
 */
const NOTICE_TEXT = {
  TEXT1:
    '※1.ご自身で応募される際にサイト上で入力した情報は、送信ボタンを押すと求人企業の採用担当者へ直接送信されます。送信ボタンを押すことで、上記についてご本人の同意があるものとします。',
  TEXT2:
    '※2.求人内容や応募結果についてのお問い合わせは求人企業へ直接ご連絡ください。dodaでは申し込みの訂正・削除などはお受けいたしかねますので予めご了承ください。',
};
